import apiClient from './client';

export interface StockItem {
  id: string;
  name: string;
  description?: string | null;
  quantity: number;
  unit: string;
  costPrice: number;
  sellingPrice: number;
  threshold: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

interface Envelope<T> { data: T; timestamp: string; }

export async function fetchStocks(inactive = false): Promise<StockItem[]> {
  const res = await apiClient.get<Envelope<StockItem[]>>(`/stock${inactive ? '?inactive=true' : ''}`);
  return res.data.data;
}

export async function reactivateStock(id: string): Promise<StockItem> {
  const res = await apiClient.patch<Envelope<StockItem>>(`/stock/${id}/reactivate`);
  return res.data.data;
}

export async function createStock(data: Omit<StockItem, 'id' | 'isActive' | 'createdAt' | 'updatedAt'>): Promise<StockItem> {
  const res = await apiClient.post<Envelope<StockItem>>('/stock', data);
  return res.data.data;
}

export async function updateStock(id: string, data: Partial<StockItem>): Promise<StockItem> {
  const res = await apiClient.put<Envelope<StockItem>>(`/stock/${id}`, data);
  return res.data.data;
}

export async function deleteStock(id: string): Promise<void> {
  await apiClient.delete(`/stock/${id}`);
}

export interface BulkImportResult {
  imported: number;
  updated: number;
  skipped: number;
  errors: { row: number; name: string; reason: string }[];
}

export async function bulkImportStock(file: File): Promise<BulkImportResult> {
  const form = new FormData();
  form.append('file', file);
  const res = await apiClient.post<Envelope<BulkImportResult>>('/stock/bulk-import', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data;
}
